export default __webpack_public_path__ + "static/media/cateringHelper.45705735.svg";